import { ICheckAccess } from '~/components/SwitchUI/types';

export const hasAccess = ({ codesToHide, elementCode }: ICheckAccess) => !codesToHide?.includes(elementCode);
